// utils/logger.js
// Logger utility with environment-aware log levels
// In prod mode, only warn and error are logged

import { IS_DEV } from '../config/env.js';

// Log levels: debug < info < warn < error
const LOG_LEVELS = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
};

// In dev: show all logs (DEBUG and above)
// In prod: show only warnings and errors (WARN and above)
const MIN_LEVEL = IS_DEV ? LOG_LEVELS.DEBUG : LOG_LEVELS.WARN;

const logger = {
    // Debug: Verbose debugging info (dev only)
    debug(...args) {
        if (MIN_LEVEL <= LOG_LEVELS.DEBUG) {
            console.log('[DEBUG]', ...args);
        }
    },

    // Info: General information messages (dev only)
    info(...args) {
        if (MIN_LEVEL <= LOG_LEVELS.INFO) {
            console.log('[INFO]', ...args);
        }
    },

    // Warn: Warnings that don't break functionality (always shown)
    warn(...args) {
        if (MIN_LEVEL <= LOG_LEVELS.WARN) {
            console.warn('[WARN]', ...args);
        }
    },

    // Error: Errors that need attention (always shown)
    error(...args) {
        if (MIN_LEVEL <= LOG_LEVELS.ERROR) {
            console.error('[ERROR]', ...args);
        }
    },

    // Game: Game event messages like XP gains, level ups (dev only)
    // Uses info level but with a distinct prefix
    game(...args) {
        if (MIN_LEVEL <= LOG_LEVELS.INFO) {
            console.log('[GAME]', ...args);
        }
    },

    // Save: Save/load related messages (dev only)
    save(...args) {
        if (MIN_LEVEL <= LOG_LEVELS.INFO) {
            console.log('[SAVE]', ...args);
        }
    },
};

export default logger;
